/* Maison Universal — global.js */
document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Collection sort
  var sort = document.querySelector('[data-sort-by]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Product page: variant + gallery
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var jsonEl = document.querySelector('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var selects = productForm.querySelectorAll('[data-option-select]');
    var idInput = productForm.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var comparePriceEl = document.querySelector('[data-compare-price]');
    var addBtn = productForm.querySelector('[data-add-to-cart]');

    function formatMoney(cents) {
      var el = document.querySelector('[data-money-format]');
      var fmt = el ? el.getAttribute('data-money-format') : '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }

    function currentVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function update() {
      var v = currentVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (comparePriceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          comparePriceEl.textContent = formatMoney(v.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (v.featured_image && v.featured_image.src) {
        var main = document.querySelector('[data-main-image]');
        if (main) main.src = v.featured_image.src;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    if (selects.length) update();

    // Thumbnails
    document.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var main = document.querySelector('[data-main-image]');
        if (main) main.src = btn.getAttribute('data-thumb');
        document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }
});
